<script>
import SelectDropdown from "../SelectDropdown.vue";
import ProjectsDropdown from "../ProjectsDropdown.vue";
import InputField from "../InputField.vue";
import StyleBox from "../StyleBox.vue";
import ColorSchemeBox from "../ColorSchemeBox.vue";
import TOCTemp1 from "../templates/TableOfContent/TOCTemp1.vue";
import TOCTemp2 from "../templates/TableOfContent/TOCTemp2.vue";
import TOCTemp3 from "../templates/TableOfContent/TOCTemp3.vue";
import TOCTemp4 from "../templates/TableOfContent/TOCTemp4.vue";
import TOCTemp5 from "../templates/TableOfContent/TOCTemp5.vue";
import TOCTemp6 from "../templates/TableOfContent/TOCTemp6.vue";
import TOCTemp7 from "../templates/TableOfContent/TOCTemp7.vue";
import PreviewTemplates from "../PreviewTemplates.vue";
import { isTOCReady } from "@/utils/proposalValidation";
import img1 from "@/assets/images/templates/TOCTemp1.png";
import img2 from "@/assets/images/templates/TOCTemp2.png";
import img3 from "@/assets/images/templates/TOCTemp3.png";
import img4 from "@/assets/images/templates/TOCTemp4.png";
import img5 from "@/assets/images/templates/TOCTemp5.png";
import img6 from "@/assets/images/templates/TOCTemp6.png";
import img7 from "@/assets/images/templates/TOCTemp7.png";

export default {
    name: "StepTOC",
    components: {
        SelectDropdown,
        ProjectsDropdown,
        InputField,
        StyleBox,
        ColorSchemeBox,
        TOCTemp1,
        TOCTemp2,
        TOCTemp3,
        TOCTemp4,
        TOCTemp5,
        TOCTemp6,
        TOCTemp7,
        PreviewTemplates,
    },
    props: {
        proposal: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            warning: "",
            TemplateList: [
                {
                    label: '1- Display 2 projects each page in 2 column layout',
                    value: 1,
                    preview: img1,
                    orientation: 'portrait',
                    style: this.getTemplateStyle(1)
                },
                {
                    label: '2- Display 1 project each page dividing page into 2 sections horizontally',
                    value: 2,
                    preview: img2,
                    orientation: 'portrait',
                    style: this.getTemplateStyle(2)
                },
                {
                    label: '3- Display project photo background with overlay with centered layout',
                    value: 3,
                    preview: img3,
                    orientation: 'portrait',
                    style: this.getTemplateStyle(3)
                },
                {
                    label: '4- Display solid color as background with centered layout',
                    value: 4,
                    preview: img4,
                    orientation: 'portrait',
                    style: this.getTemplateStyle(4)
                },
                {
                    label: '1- Display project as background with two column layout',
                    value: 5,
                    preview: img5,
                    orientation: 'landscape',
                    style: this.getTemplateStyle(5)
                },
                {
                    label: '2- Display 2 rows layout top content and bottom project photo',
                    value: 6,
                    preview: img6,
                    orientation: 'landscape',
                    style: this.getTemplateStyle(6)
                },
                {
                    label: '3- Display 2 columns layout left content and right project photo',
                    value: 7,
                    preview: img7,
                    orientation: 'landscape',
                    style: this.getTemplateStyle(7)
                }
            ],
            itemsPerPageOptions: [
                { label: "2 Items per page", value: 2 },
                { label: "4 Items per page", value: 4 },
                { label: "6 Items per page", value: 6 },
                { label: "8 Items per page", value: 8 },
                { label: "10 Items per page", value: 10 },
                { label: "12 Items per page", value: 12 },
                { label: "14 Items per page", value: 14 },
                { label: "16 Items per page", value: 16 },
                { label: "18 Items per page", value: 18 },
                { label: "20 Items per page", value: 20 },
                { label: "22 Items per page", value: 22 },
                { label: "24 Items per page", value: 24 },
                { label: "26 Items per page", value: 26 },
                { label: "28 Items per page", value: 28 },
                { label: "30 Items per page", value: 30 },
            ]
        };
    },
    computed: {
        isPreviewable() {
            return isTOCReady(this.proposal.toc);
        },
        previewText() {
            if (this.proposal.toc.template === "") {
                return "Please select a template to see preview";
            }
            if (!this.proposal.toc.pages || this.proposal.toc.pages.length === 0) {
                return "Please add at least one page";
            }
            if (this.proposal.toc.pages.some((item) => item.page === "" || item.heading === "")) {
                return "Please fill all Table of Contents list";
            }
            return "";
        }
    },
    methods: {
        getTemplateStyle(t) {
            return {
                colorScheme: {
                    header: t == 3 ? "#181c45" : t == 4 || t == 7 || t == 5 ? "#ffffff" : t == 6 ? "#00be62" : "#545454",
                    body: t == 3 ? "#181c45" : t == 4 ? "#00be62" : t == 5 || t == 6 || t == 7 ? "#e3e3e4" : "#545454",
                    footer: t == 3 ? "#ffffff" : t == 4 || t == 6 ? "#ffffff" : t == 5 ? "#181c45" : t == 7 ? "#000000" : "#545454",
                },
                heading: {
                    color: t == 3 || t == 4 || t == 6 ? "#ffffff" : t == 5 ? "#002b61" : t == 7 ? "#000000" : "#004aac",
                    size: t == 5 || t == 6 ? "48" : t == 7 ? "28" : "36",
                    font: "Arial",
                    bold: t == 3 || t == 4 ? false : true,
                    italic: false,
                    underline: false,
                },
                label: {
                    color: t == 3 || t == 4 || t == 6 ? "#ffffff" : t == 5 ? "#002b61" : t == 7 ? "#000000" : "#004aac",
                    size: "16",
                    font: "Arial",
                    bold: t == 2 ? false : true,
                    italic: false,
                    underline: false,
                },
                text: {
                    color: t == 3 || t == 4 || t == 6 ? "#ffffff" : t == 5 ? "#002b61" : t == 7 ? "#000000" : "#004aac",
                    size: "16",
                    font: "Arial",
                    bold: t == 2 || t == 5 || t == 6 ? true : false,
                    italic: false,
                    underline: false,
                },
            };
        },
        fixStyling() {
            const match = this.TemplateList.find(item => item.value === this.proposal.toc.template);
            if (match) this.proposal.toc.style = match.style;
        },
        handleTemplateSelection(val) {
            this.proposal.toc.template = val;
            if (val === 1) {
                this.proposal.toc.itemsPerPage = 24;
            }
            if (val == 2 || val == 4 || val == 6 || val == 7) {
                this.proposal.toc.itemsPerPage = 16;
            }
            if (val === 3) {
                this.proposal.toc.projects = (this.proposal.toc.projects || []).slice(0, 1);
                this.proposal.toc.itemsPerPage = 18;
            }
            if (val === 5) {
                this.proposal.toc.itemsPerPage = 26;
            }
            this.fixStyling();
        },
        handleProjectSelection(projects) {
            this.proposal.toc.projects = projects;
        },
        handleItemsPerPageUpdate(val) {
            this.proposal.toc.itemsPerPage = parseInt(val) || 10;
        }
    }
};
</script>


<template>
  <div class="d-flex flex-column w-100 bg-white rounded-lg text-left">
    <div class="d-flex flex-column">
      <h4 class="mb-3 font-weight-bold">Table of Contents</h4>
      <div class="row">
        <div class="col-12 mb-3">
          <SelectDropdown label="Template" :modelValue="proposal.toc.template"
            :options="TemplateList.filter(item => item.orientation === proposal.pageOrientation)"
            placeholder="Select Template" @update:modelValue="handleTemplateSelection" :isPreviewable="true" />
        </div>
      </div>
      <div v-if="proposal.toc.template" class="row">
        <div class="col-12 col-md-6 mb-3">
          <InputField label="Page Title" :modelValue="proposal.toc.title" placeholder="Enter Page Title"
            @update:modelValue="proposal.toc.title = $event" />
        </div>
        <div class="col-12 col-md-6 mb-3">
          <SelectDropdown label="Items per Page" :modelValue="proposal.toc.itemsPerPage" :options="itemsPerPageOptions"
            placeholder="Select Items per Page" @update:modelValue="handleItemsPerPageUpdate" />
        </div>

        <div v-if="proposal.toc.template !== 4" class="col-12 col-md-6 mb-3">
          <ProjectsDropdown label="Projects" :modelValue="proposal.toc.projects"
            :disabled="!proposal.toc.template || proposal.toc.template === 4"
            @update:modelValue="handleProjectSelection" />
        </div>
      </div>
      <div v-if="proposal.toc.template" class="mb-3">
        <div class="row">
          <div class="col-12 d-flex justify-content-between align-items-center mb-1">
            <label class="label">Table of Contents</label>
          </div>
          <div class="col-12">
            <p v-if="warning" class="warning-msg">{{ warning }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <p class="preview-text" v-if="proposal.toc.pages.length === 0">
              Added pages will be displayed here
            </p>
          </div>
        </div>

        <div class="row no-gutters align-items-center" v-for="(item) in proposal.toc.pages" :key="item.id">
          <div class="col-12 mb-2 d-flex flex-row align-items-center">
            <InputField :modelValue="item.heading" placeholder="Type page heading"
              @update:modelValue="item.heading = $event" />
          </div>
        </div>
      </div>

      <div class="row" v-if="proposal.toc.template && proposal.toc.style">
        <div v-for="item in [
          { key: 'colorScheme', label: 'Color Scheme' },
          { key: 'heading', label: 'Heading Color', disabled: !proposal.toc.template || proposal.toc.template == 1 },
          { key: 'label', label: 'Label Color' },
          { key: 'text', label: 'Text Color' }
        ]" :key="item.key" class="col-12 col-md-6 col-lg-3 mb-3">
          <ColorSchemeBox v-if="item.key === 'colorScheme'" :styling="proposal.toc.style[item.key]" :label="item.label"
            :disabled="item.disabled" />
          <StyleBox v-else :styling="proposal.toc.style[item.key]" :label="item.label" :disabled="item.disabled" />
        </div>
      </div>

    </div>

    <PreviewTemplates :isPreviewable="isPreviewable" :emptyMessage="previewText">
      <TOCTemp1 v-if="proposal.toc.template === 1" :toc="proposal.toc" />
      <TOCTemp2 v-if="proposal.toc.template === 2" :toc="proposal.toc" />
      <TOCTemp3 v-if="proposal.toc.template === 3" :toc="proposal.toc" />
      <TOCTemp4 v-if="proposal.toc.template === 4" :toc="proposal.toc" />
      <TOCTemp5 v-if="proposal.toc.template === 5" :toc="proposal.toc" />
      <TOCTemp6 v-if="proposal.toc.template === 6" :toc="proposal.toc" />
      <TOCTemp7 v-if="proposal.toc.template === 7" :toc="proposal.toc" />
    </PreviewTemplates>
  </div>
</template>

<style scoped lang="scss">
.label {
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 0px;
}

.gap-2 {
  gap: 2px;
}

.placeholder-text {
  border: 1px solid #ced4da;
  padding: 10px;
  color: #6c757d;
  font-size: 12px;
}

.preview-text {
  display: flex;
  flex-direction: column;
  min-height: 39px;
  width: 100%;
  align-items: center;
  justify-content: center;
  overflow: auto;
  border: 1px solid #dddddd;
  border-radius: 4px;
  color: #727070;
  font-size: 12px;
  margin: 0;
}

.warning-msg {
  color: white;
  font-size: 12px;
  background: #c53f3f;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 4px;
}
</style>
